import { useRoleContext, useShipmentQuotes } from "hooks";
import { getBookedQuoteFromQuotes } from "utils";

import { CarrierView } from "./CarrierView";
import { ShipperView } from "./ShipperView";

interface Props {
  shipment: CondensedShipment;
}

export function ShipmentDetailShipmentBookedBy(props: Props) {
  const { shipment } = props;
  const { quotes } = useShipmentQuotes(shipment.info.id);
  const { role } = useRoleContext();
  const bookedQuote = getBookedQuoteFromQuotes(quotes);

  if (role?.type === "SHIPPER") {
    return <ShipperView bookedQuote={bookedQuote} />;
  }

  if (role?.type === "CARRIER") {
    return <CarrierView shipment={shipment} bookedQuote={bookedQuote} />;
  }

  return null;
}
